import { mainUrl } from "../../../api/apiSettings";

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/topic
export const CREATE_TOPIC = `${mainUrl}/forum/topic`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/topic/{journeyId}
export const QUERY_TOPICS = (journeyId) => `${mainUrl}/forum/topic/${journeyId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post
export const CREATE_POST = `${mainUrl}/forum/post`;

// PATCH - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/{topicId}/{postId}
export const EDIT_POST = (topicId, postId) => `${mainUrl}/forum/post/${topicId}/${postId}`;

// DELETE - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/{topicId}/{postId}
export const DELETE_POST = (topicId, postId) => `${mainUrl}/forum/post/${topicId}/${postId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/{topicId}
export const QUERY_POSTS = (topicId) =>  `${mainUrl}/forum/post/${topicId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/like/add
export const ADD_LIKE = `${mainUrl}/forum/post/like/add`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/like/remove
export const REMOVE_LIKE = `${mainUrl}/forum/post/like/remove`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/post/like/{postId}/{userId}
export const GET_USER_LIKE = (postId, userId) => `${mainUrl}/forum/post/like/${postId}/${userId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/forum/topic/solution
export const MARK_SOLUTION = `${mainUrl}/forum/topic/solution`;
